import { render, staticRenderFns } from "./displayPremiums.vue?vue&type=template&id=c0ab9928&scoped=true&"
import script from "./displayPremiums.vue?vue&type=script&lang=js&"
export * from "./displayPremiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ab9928",
  null
  
)

export default component.exports